(function () {
  var settings = window.dwMemberPricing || {};
  var labels = settings.labels || {};
  var prompt = document.querySelector('dialog[data-dw-member-prompt]');
  var recognitionKey = 'dw_member_recognition';
  var sessionKey = 'dw_member_prompt_seen';
  var unknownKey = 'dw_member_prompt_unknown_dismissed_at';
  var recognizedKey = 'dw_member_prompt_recognized_dismissed_at';
  var currentDismissalKey = unknownKey;
  var automaticTimer;
  var manualTrigger = null;

  function read(storage, key) {
    try { return storage.getItem(key); } catch (_) { return null; }
  }
  function write(storage, key, value) {
    try { storage.setItem(key, value); } catch (_) {}
  }
  function recognizedMember() {
    try {
      var member = JSON.parse(read(window.localStorage, recognitionKey));
      return member && member.recognizedAt && Date.now() - member.recognizedAt < 365 * 86400000 ? member : null;
    } catch (_) { return null; }
  }

  if (settings.loggedIn) {
    write(window.localStorage, recognitionKey, JSON.stringify({ firstName: settings.firstName || '', recognizedAt: Date.now() }));
    return;
  }
  if (!prompt || typeof prompt.showModal !== 'function' || prompt.dataset.dwReady) return;
  prompt.dataset.dwReady = 'true';

  var member = recognizedMember();
  var primary = prompt.querySelector('[data-dw-club-continue]');
  var defaultLogin = primary.getAttribute('href');
  currentDismissalKey = member ? recognizedKey : unknownKey;

  function render() {
    var title = prompt.querySelector('[data-dw-member-prompt-title]');
    var copy = prompt.querySelector('[data-dw-member-prompt-copy]');
    if (member) {
      title.textContent = (labels.promptWelcomeTitle || 'Welcome back, [first_name]').replace('[first_name]', member.firstName || 'member');
      copy.textContent = labels.promptWelcomeCopy || copy.textContent;
      primary.textContent = labels.promptWelcomeAction || primary.textContent;
    }
  }

  function loginURL(link) {
    try {
      var url = new URL(link.getAttribute('href'), window.location.href);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      if (!/\/(?:customer_authentication\/login|account(?:\/login|\/register)?)\/?$/.test(url.pathname)) return null;
      return url;
    } catch (_) { return null; }
  }

  function refreshDestination(link) {
    var url = loginURL(link);
    if (!url) return;
    var path = new URL(window.location.href);
    path.searchParams.delete('preview_theme_id');
    if (/\/customer_authentication\/login\/?$/.test(url.pathname)) {
      url.searchParams.set('return_to', path.pathname + path.search);
    }
    primary.href = url.href;
  }

  function open(link) {
    window.clearTimeout(automaticTimer);
    if (link) {
      manualTrigger = link;
      refreshDestination(link);
    } else {
      primary.href = defaultLogin;
      refreshDestination(primary);
    }
    write(window.sessionStorage, sessionKey, 'true');
    if (prompt.open) return;
    render();
    prompt.showModal();
    document.body.classList.add('dw-member-prompt-open');
  }

  prompt.querySelector('[data-dw-member-prompt-close]').addEventListener('click', function () { prompt.close(); });
  prompt.addEventListener('click', function (event) {
    if (event.target !== prompt) return;
    var rect = prompt.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) prompt.close();
  });
  prompt.addEventListener('close', function () {
    document.body.classList.remove('dw-member-prompt-open');
    write(window.localStorage, currentDismissalKey, String(Date.now()));
    if (manualTrigger && manualTrigger.isConnected) manualTrigger.focus();
    manualTrigger = null;
  });

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    var link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!link || prompt.contains(link) || link.hasAttribute('download') || (link.target && link.target !== '_self')) return;
    if (!loginURL(link)) return;
    event.preventDefault();
    open(link);
  });

  var blockedPath = /^\/(account|cart|checkout|checkouts|challenge)(\/|$)/.test(window.location.pathname);
  var dismissedAt = parseInt(read(window.localStorage, currentDismissalKey), 10);
  if (!member && !dismissedAt) dismissedAt = parseInt(read(window.localStorage, 'dw_member_prompt_dismissed_at'), 10);
  var suppressed = blockedPath || read(window.sessionStorage, sessionKey) === 'true' ||
    (dismissedAt && Date.now() - dismissedAt < (member ? 3 : 7) * 86400000);
  if (settings.mode === 'open_sale' || suppressed) return;
  automaticTimer = window.setTimeout(function () { open(); }, member ? 0 : (/^\/products\//.test(window.location.pathname) ? 12000 : 5000));
})();
